/* AutoAssignVeilRenderer.js */

"use strict";
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const InputRadioControl = require("@gluenetworks/steve_ui_core").Control.OptionSelection.Single
    .InputRadio;
const InputTextControl = require("@gluenetworks/steve_ui_core").Control.Textfield.InputText;

class AutoAssignVeilRenderer {
    constructor(model, hasSelection) {
        this._model = model;
        this._rootElem = document.createElement("auto-assign-veil-gl");
        this._rootElem.component = this._model;

        this._titleComponent = document.createElement("h2");
        this._titleComponent.innerText = "Site auto-assignment";

        const scopeOptions = [
            ...(hasSelection ? [{label: "Selection", value: "selection"}] : []),
            {label: "Apply Current Filter", value: "filter"},
            {label: "All", value: "all"},
        ];

        this._scopeRadio = new InputRadioControl({
            label: "Scope",
            labelShown: true,
            horizontal: true,
            options: scopeOptions,
            value: hasSelection ? "selection" : "all",
            darkTheme: true,
        });

        const now = new Date();
        this._nameInput = new InputTextControl({
            darkTheme: true,
            value:
                "Auto Assignment scheduled on " +
                now.toLocaleDateString() +
                " " +
                now.toLocaleTimeString(),
        });

        this._buttonContainer = document.createElement("button-container");
        this._msgComponent = document.createElement("msg");

        this._cancelButton = new ButtonControl({
            label: "Cancel",
            darkTheme: true,
        });

        this._scheduleButton = new ButtonControl({
            label: "Schedule",
            darkTheme: true,
        });
        this._scheduleButton.setDisabled(this._model.scope !== "all");

        this._runNowButton = new ButtonControl({
            label: "Run Now",
            darkTheme: true,
            type: "additive",
        });

        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._scopeRadio.on("UserValue", (this._onScopeChange = this._onScopeChange.bind(this)));
        this._cancelButton.on("UserClick", (this._onCancelClick = this._onCancelClick.bind(this)));
        this._scheduleButton.on(
            "UserClick",
            (this._onScheduleClick = this._onScheduleClick.bind(this))
        );
        this._runNowButton.on("UserClick", (this._onRunNowClick = this._onRunNowClick.bind(this)));
    }

    _unregisterListeners() {
        this._scopeRadio.removeAllListeners("UserValue");
        this._cancelButton.removeAllListeners("UserClick");
        this._scheduleButton.removeAllListeners("UserClick");
        this._runNowButton.removeAllListeners("UserClick");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    /* jshint ignore:start */
    async shutdown() {
        this._unregisterListeners();
        await Promise.all([
            this._scopeRadio.shutdown(),
            this._nameInput.shutdown(),
            this._cancelButton.shutdown(),
            this._scheduleButton.shutdown(),
            this._runNowButton.shutdown(),
        ]);
        this._scopeRadio = undefined;
        this._nameInput = undefined;
        this._cancelButton = undefined;
        this._scheduleButton = undefined;
        this._runNowButton = undefined;
        this._buttonContainer.remove();
        this._buttonContainer = undefined;
        this._titleComponent.remove();
        this._titleComponent = undefined;
        this._msgComponent = undefined;
        this._rootElem.remove();
        this._rootElem = undefined;
        this._model = undefined;
    }
    /* jshint ignore:end */

    render() {
        return new Promise((resolve) => {
            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._titleComponent);
                this._rootElem.appendChild(this._scopeRadio.renderer.rootElement);
                this._rootElem.appendChild(this._nameInput.renderer.rootElement);
                this._rootElem.appendChild(this._buttonContainer);
                this._rootElem.appendChild(this._msgComponent);

                this._buttonContainer.appendChild(this._cancelButton.renderer.rootElement);
                this._buttonContainer.appendChild(this._scheduleButton.renderer.rootElement);
                this._buttonContainer.appendChild(this._runNowButton.renderer.rootElement);
            }
            resolve();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onScopeChange(value) {
        this._model.setScope(value);
        this._updateScheduleButton();
    }

    _updateScheduleButton() {
        this._scheduleButton.setDisabled(this._model.scope !== "all");
    }

    _onCancelClick() {
        this._model.cancel();
    }

    _onScheduleClick() {
        this._model.schedule(this._nameInput.value);
    }

    _onRunNowClick() {
        this._model.runNow();
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /*******************************************/
}

module.exports = AutoAssignVeilRenderer;
